<footer class="mt-2">
  <div class="container-fluid bg-purple text-white">
    <div class="container py-4">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4 mb-4 mb-sm-0">

          <h5 class="text-white mb-2 pt-3">Follow us on</h5>
          <ul class="link-list link-list--inline social-links__content">

            <li>
              <a target="_blank" id="phfooter_0_SocialLinkList_LinkListRepeater_lnkFooterLink_0" href="https://www.linkedin.com/company/together-loans-mortgages-and-finance">
                <img src="../assets/images/linkedin.svg" class="social-links__icon inline-height-width" alt="LinkedIn" width="40" height="40">
                <abbr class="accessible-hidden">

                </abbr>
              </a>
            </li>

            <li>
              <a target="_blank" id="phfooter_0_SocialLinkList_LinkListRepeater_lnkFooterLink_1" href="">
                <img src="../assets/images/youtube.svg" class="social-links__icon inline-height-width" alt="Youtube" width="40" height="40">
                <abbr class="accessible-hidden">

                </abbr>
              </a>
            </li>

            <li>
              <a target="_blank" id="phfooter_0_SocialLinkList_LinkListRepeater_lnkFooterLink_2" href="https://twitter.com/Together_Money">
                <img src="../assets/images/twitter.svg" class="social-links__icon inline-height-width" alt="Twitter" width="40" height="40">
                <abbr class="accessible-hidden">

                </abbr>
              </a>
            </li>

          </ul>

        </div>
        <div class="col-12 col-sm-6 col-md-4 mb-2 mb-sm-0">
          <div class="border-dr-1">
            <ul class="list-unstyled pt-3">
              <li>
                <a target="_blank" href="https://togethermoney.com/website-terms-of-use/" title="Website Terms of Use">Website Terms of Use</a>
              </li>
              <li>
                <a target="_blank" href="https://togethermoney.com/privacy-and-cookie-policy/" title="Privacy and cookie policy">Privacy and cookie policy</a>
              </li>
              <li>
                <a target="_blank" href="https://togethermoney.com/company-policies/">Company policies</a>
              </li>
              <li>
                <a target="_blank" href="https://togethermoney.com/fair-processing-notice/">Fair Processing Notice</a>
              </li>

              <li>
                <a target="_blank" href="https://togethermoney.com/about-us/" title="About Us">About Us</a>
              </li>
              <li>
                <a target="_blank" href="https://togethermoney.com/get-in-touch/" title="Get in touch">Get in touch</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-12 col-md-4 mb-2 mb-sm-0">
          <div class="border-dr-1 copyright pt-3">
            Copyright {{currentYear}}
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid bg-darkpurple text-white">
    <div class="container py-4">
      <div class="row">
        <div class="col-12 text-white mt-4">
          <small>Together is a trading style of each of the undernoted companies, which have their registered office address at
            Lake View, Lakeside, Cheadle, Cheshire SK8 3GW.</small>

          <small>Together Financial Services Limited Registered in England and Wales - Company Registration Number 02939389. Together
            Financial Services Limited is the operator of this website.</small>

          <small>Together Personal Finance Limited is authorised and regulated by the Financial Conduct Authority (FCA) | Registered
            in England and Wales - Company Registration Number 02613335. FCA number is 305253.</small>

          <small>Together Commercial Finance Limited | Registered in England and Wales - Company Registration Number 02058813
          </small>

          <small>Spot Finance Limited is authorised and regulated by the Financial Conduct Authority (FCA) | Registered in England
            and Wales - Company Registration Number 01998543
            <br> Auction Finance Limited | Registered in England and Wales - Company Registration Number 04949929
            <br> Bridging Finance Limited | Registered in England and Wales - Company Registration Number 03166982</small>

          <small>Blemain Finance Limited is authorised and regulated by the Financial Conduct Authority in respect of second charge
            loans secured on residential property | Registered in England and Wales - Company Registration Number 01185052.
            Blemain Finance Limited is a member of the Finance and Leasing Association (FLA). The FLA Lending Code can be
            found at
            <u>
              <a target="_blank" href="http://www.fla.org.uk/" title="Financial  and Leasing Association">www.fla.org.uk</a>
            </u>.</small>
        </div>
      </div>
    </div>
  </div>
</footer>
